import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const roleService = {
  getAllRoles,
  getRole,
  createRole,
  updateRole,
  updateRoleStatus,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = {
    page: filter?.pageNumber,
    size: filter?.pageSize,
  }
  if (filter?.isActive !== undefined && filter?.isActive !== null && filter?.isActive !== '') {
    params.is_active = filter.isActive
  }
  filter?.searchArray?.forEach((word, idx) => {
    if (word !== null && word !== '') params[`search_words[${idx}]`] = word
  })
  return params
}

export async function getAllRoles(filter) {
  return apiHelper(API_URL).get('/roles', { params: buildParams(filter) })
}

export async function getRole(uuid) {
  return apiHelper(API_URL).get(`/roles/${uuid}`)
}

export async function createRole(data) {
  return apiHelper(API_URL).post('/roles', {
    name: data.name,
    permission_codes: data.permissionCodes || [],
  })
}

export async function updateRole(uuid, data) {
  return apiHelper(API_URL).put(`/roles/${uuid}`, {
    name: data.name,
    permission_codes: data.permissionCodes || [],
  })
}

export async function updateRoleStatus(uuid, isActive) {
  return apiHelper(API_URL).patch(`/roles/${uuid}`, { is_active: isActive })
}
